import { Tooltip as RadixTooltip } from 'radix-ui';
import type { ReactNode } from 'react';
import './Tooltip.css';

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
}

/**
 * Radix's Tooltip already provides what a11y.md requires and the prototype
 * never had: it shows on keyboard focus as well as hover/pointer, and
 * dismisses on Escape. Used here rather than a hand-rolled hover-only
 * implementation — a hover-only tooltip fails any keyboard-only user by
 * construction (see docs/design-system/patterns.md's tenant-aware
 * Timestamp note, which depends on exactly this behaviour).
 */
export function Tooltip({ content, children }: TooltipProps) {
  return (
    <RadixTooltip.Provider delayDuration={200}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content className="dpr-tooltip" sideOffset={6}>
            {content}
            <RadixTooltip.Arrow className="dpr-tooltip__arrow" />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
